import { StateParams } from '@uirouter/angularjs';
import * as angular from 'angular';
import * as _ from 'underscore';
import { AnalyticsService, ICollectedAnalyticsData } from './analytics.service';

export abstract class AnalyticsBase {

    public breakdowns: string[];
    public filter: {
        startDate: number;
        endDate: number;
        breakdown: string;
        group?: string;
    };
    public timeFormat: string = null;
    public dataset: ICollectedAnalyticsData[] = null;
    public tabs = [this.$translate.instant('gender'),
        this.$translate.instant('age'),
        this.$translate.instant('interests')];

    protected id: number;

    private defaultMonthsPeriod = 6;
    private startDate = new Date();
    private endDate = new Date();
    private readonly dayBreakdown = this.$translate.instant('day');
    private readonly weekBreakdown = this.$translate.instant('week');
    private readonly monthBreakdown = this.$translate.instant('month');
    private dateFilter = this.$filter('date');
    private numberFilter = this.$filter('number');
    private intervalInDays: number = null;
    private tooltipDateFormat = 'd MMM';

    constructor(
        protected $scope: ng.IScope,
        protected $stateParams: StateParams,
        protected $filter: ng.IFilterService,
        protected analiticsService: AnalyticsService,
        protected $translate: angular.translate.ITranslateService
    ) {
        this.id = parseInt($stateParams.id, 10);
        this.startDate.setMonth(this.startDate.getMonth() - this.defaultMonthsPeriod);
        this.breakdowns = [this.dayBreakdown, this.weekBreakdown, this.monthBreakdown];

        this.filter = {
            startDate: this.startDate.setHours(0, 0, 0, 0),
            endDate: this.endDate.setHours(0, 0, 0, 0),
            breakdown: ''
        };

        this.intervalInDays = (this.filter.endDate - this.filter.startDate) / 24 / 60 / 60 / 1000;
        if (this.intervalInDays < 7) {
            this.filter.breakdown = this.dayBreakdown;
        } else if (this.intervalInDays < 30) {
            this.filter.breakdown = this.weekBreakdown;
        } else {
            this.filter.breakdown = this.monthBreakdown;
        }
        this.setFilterExtension();
        $scope.$watch('vm.filter', this.refresh, true);
    }

    public tooltipFormat = (label: string, x: string, y: string) => {
        let xFormatted = '';
        const yFormatted = this.numberFilter(y);
        switch (this.filter.breakdown) {
            case this.weekBreakdown:
                const dateFrom = new Date(x);
                const dateTo = new Date(x);
                const dayOfWeek = (dateTo.getDay() + 6) % 7;
                dateTo.setDate(dateTo.getDate() + 6 - dayOfWeek);
                xFormatted = this.dateFilter(dateFrom, this.tooltipDateFormat) + ' - ' + this.dateFilter(dateTo, this.tooltipDateFormat);
                break;
            default:
                xFormatted = '%x';
                break;
        }

        return `${xFormatted} : ${yFormatted}`;
    }

    public setBreakdown = (value: string) => {
        this.filter.breakdown = value;
        this.refresh();
    }

    protected abstract getData(id: number, filter: any): angular.IPromise<ICollectedAnalyticsData[]>;
    protected abstract setFilterExtension(): void;

    private getTimeFormat = () => {
        switch (this.filter.breakdown) {
            case this.monthBreakdown:
                return '%b %Y';
            default:
                return '%e %b';
        }
    }

    private refresh = async () => {
        const dataset = await this.getData(this.id, this.filter);
        try {
            this.dataset = dataset;
            this.timeFormat = this.getTimeFormat();
        } catch (error) {
            console.warn(error);
        }
    }
}



// WEBPACK FOOTER //
// ./~/tslint-loader!./src/app.retailer/modules/analytics/analyticsBase.ts